/** @jsxRuntime classic */ // <-- remove this when TS updated to 4.1
/** @jsx jsx */ // <-- remove this when TS updated to 4.1
import { jsx } from '@emotion/core';
import { FC, ReactNode } from 'react';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { Azoomee, DaVinci } from '../../icons';
import { Copy, ROUTES, ThemeProps } from '../../../types';
import { getBaseUrl, storageBucket } from '../../../utils';

interface HeaderProps extends Copy {
  /**
   * Button contents
   */
  children: ReactNode;
  /**
   * The css class for the input. Handled internally by emotion
   */
  className?: string;

  headerIcon?: string;
}

const Header: FC<HeaderProps> = ({ className, headerIcon }) => {
  var partnerLogo = headerIcon?.replace("{STORAGE_BUCKET}", `${storageBucket}`);
  if (!partnerLogo || partnerLogo === "") {
    return (
      <header className={className}>
        <div className='logo-container'>
          <Link to={ROUTES.DASHBOARD}>
            {getBaseUrl()!.includes('azoomee') ? <Azoomee /> : <DaVinci />}
          </Link>
        </div>
      </header>
    );
  } else {
    return (
      <header className={className}>
        <div className='logo-container'>
          <Link to={ROUTES.DASHBOARD}>
            {(
              <img
                className='partner-logo'
                src={partnerLogo}
                alt=''
              />
            )}
          </Link>
        </div>
      </header>
    );
  }
};

const StyledHeader = styled((props: any) => <Header {...props} />)`
  ${({ theme }: { theme: ThemeProps }) => ({
    alignItems: 'center',
    backgroundColor: theme.colors.background.paper,
    display: 'flex',
    flexDirection: 'row',
    height: 60,
    justifyContent: 'space-between',
    padding: '20px 16px',
    a: {
      height: '100%',
    },
    [theme.mq.desktop]: {
      padding: '20px 40px',
    },
    div: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      height: '100%',
    },
    img: {
      height: '100%',
      width: 100,
      [theme.mq.desktop]: {
        width: 'auto',
      },
    },
    svg: {
      height: '100%',
    },
    '.loginText': {
      display: 'none',
      [theme.mq.desktop]: {
        display: 'inline',
      },
    },
  })}
`;

export default StyledHeader;
